import util from '../util'

let controller = 'OperacaoBACEN'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetOperacaoBACEN: function () {
        return util.Axios.Get(controller + '/All')
  },
  GetListaCodDBSOperacaoBACEN: function (dto) {
    return util.Axios.GetAll(controller + '/ListaCodBDS', dto, true)
  },
  Post: function (dto) {
    return util.Axios.Post(controller, dto)
  },
  DeleteOperacaoBACEN: function (id){
    return util.Axios.Delete(controller, id)
  }
})